import { Stepper } from "@/components/Stepper";
import CharacterCreationStep from "@/components/StepperComponents/CharacterCreationStep";
import GettingStartedStep from "@/components/StepperComponents/GettingStartedStep";
import ThemeStep from "@/components/StepperComponents/ThemeStep";
import WorldBuildingStep from "@/components/StepperComponents/WorldSettingStep";
import { StepperProvider, useStepper } from "@/components/StepperProvider";
import WhimsicalBackground from "@/components/WhimsicalBackground";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useFeature } from "@/hooks/use-feature";
import StoryLimitPage from "./CreateStoryLimitPage";

const STEPS = [
    "Getting Started",
    "Characters",
    "World Setting",
    "Story Theme",
];

const CreateBookPage = () => {
    const { limits } = useFeature();
    let hasReachedLimit = false;
    if (limits?.storyCreate) {
        if (limits?.storyCreate?.daily !== 0) {
            hasReachedLimit = limits?.currentUsage?.dailyStories >= limits?.storyCreate?.daily;
        } else {
            hasReachedLimit = limits?.currentUsage?.totalStories >= limits?.storyCreate?.total;
        }
    }

    return (
        <>
            {hasReachedLimit ? (
                <StoryLimitPage plan={limits?.plan} />
            ) : (
                <div>
                    <WhimsicalBackground />
                    <StepperProvider totalSteps={STEPS.length}>
                        <StepperCard />
                    </StepperProvider>
                </div>
            )}
        </>
    );
};

const StepperCard = () => {
    const { currentStep } = useStepper();

    return (
        <div className="container px-4 py-8 mx-auto">
            <h1 className="mb-6 text-2xl font-bold text-center">Create Your Story</h1>
            <Stepper steps={STEPS} currentStep={currentStep} />
            <Card className="p-6 mx-auto mt-6 md:max-w-xl">
                <h2 className="mb-6 text-xl font-bold text-center">{STEPS[currentStep]}</h2>
                <Separator className={"mb-6"} />
                <StepContent />
            </Card>
        </div>
    )
}

const StepContent = () => {
    const { currentStep } = useStepper();

    switch (currentStep) {
        case 0:
            return <GettingStartedStep />;
        case 1:
            return <CharacterCreationStep />;
        case 2:
            return <WorldBuildingStep />;
        case 3:
            return <ThemeStep />;
        default:
            return null;
    }
};

export default CreateBookPage;
